import { connect } from 'react-redux';
import { compose } from 'ramda';
import { withRouter } from 'react-router-dom';
import EndFields from 'components/DetailedEPReport/components/EndFields';
import { FORM_NAMES } from 'constants/forms';
import { NOT_APPLICABLE } from 'constants/common';
import {
  isAnyVentricularArrhythmiasDetectedFieldOpen,
  isAnyAtrialArrhythmiasDetectedFieldOpen,
} from 'store/selectors/reports/singleItems';
import { formValueSelector, change } from 'redux-form';
import { getUserRole } from 'store/selectors/user';

const transmissionFormSelector = formValueSelector(FORM_NAMES.transmissionReportSummary);
const detailedReportFormInitialSelector = formValueSelector(FORM_NAMES.detailedEPReport);

const mapStateToProps = (state, { match: { path } }) => ({
  isAnyVentricularArrhythmiasDetectedOpen: isAnyVentricularArrhythmiasDetectedFieldOpen(state),
  isAnyAtrialArrhythmiasDetectedOpen: isAnyAtrialArrhythmiasDetectedFieldOpen(state),
  leadsPresent: path.match('/new')
    ? transmissionFormSelector(state, 'leadsPresent')
    : detailedReportFormInitialSelector(state, 'leadsPresent'),
  formName: path.match('/new') ? FORM_NAMES.transmissionReportSummary : FORM_NAMES.detailedEPReport,
  userRole: getUserRole(state),
});

const mapDispatchToProps = dispatch => ({
  handleAtrialPresentLeadClick: formName => ({ target: { checked } }) => {
    dispatch(change(formName, 'percentAtrialPacing', checked ? '' : NOT_APPLICABLE));
  },
});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(EndFields);
